import "./src/styles/global.css"
import React from "react"
import LocationContext from "./src/context/location-context"
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper"
import { IntlProvider } from "react-intl"
import loadLocaleData from "./src/lang/utils"

SwiperCore.use([Pagination, Navigation, Autoplay])

// Netlify Identity redirect handler for CMS login
if (typeof window !== "undefined" && window.netlifyIdentity) {
  window.netlifyIdentity.on("init", user => {
    if (!user) {
      window.netlifyIdentity.on("login", () => {
        document.location.href = "/admin/"
      })
    }
  })
}

export const wrapPageElement = ({
  element,
  props: { location, pageContext },
}) => {
  return (
    <LocationContext.Provider value={location}>
      <IntlProvider
        locale={pageContext.langKey || "en"}
        defaultLocale="en"
        messages={loadLocaleData(pageContext.langKey || "en")}
      >
        {element}
      </IntlProvider>
    </LocationContext.Provider>
  )
}
